/* scroll/utils/stickyProgress.js */
export const getStickyProgress = element => {

    const rect = element.getBoundingClientRect();
    const viewportH = window.innerHeight;

    let p = 0;

    if (rect.top <= 0 && rect.bottom >= viewportH) {

        const totalH = rect.height - viewportH;
        const scrollY = rect.top * -1;

        p = (scrollY / totalH) * 100;

    } else if (rect.top > 0) {

        p = 0;

    } else {

        p = 100;

    }

    return p;

};